import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import {  useState } from "react";
import { AuthenticationService } from "../../services/AuthenticationService";
import {FaGoogle} from 'react-icons/fa'
interface IModalLoginProps {
  onClose: ()=>void,
  isOpen: boolean
}
export const ModalLogin = (props: IModalLoginProps) => {
  const {onClose, isOpen} =props
  const {login} = AuthenticationService();
  const [loading, setLoading] = useState<boolean>(false);

  const loginUser = async() => {
    setLoading(true);
    await login()
    setLoading(false);
    onClose()
  };

  return (
    <>
      <Modal onClose={onClose} isOpen={isOpen} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>¡Hola! </ModalHeader>
          <ModalCloseButton />
          <ModalBody>Para comprar debes ingresar a tu cuenta.</ModalBody>
          <ModalFooter display={"flex"} flexDirection="column" >
            <Button mb="3" colorScheme={"gray"} isLoading={loading} leftIcon={<FaGoogle/>} onClick={()=>loginUser()}>Ingresar con Google</Button>
            <Button onClick={onClose} variant='ghost'>Cancelar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
